import { render, staticRenderFns } from "./NewCollectionFolderModal.vue?vue&type=template&id=dd3206d0&lang=pug&"
import script from "./NewCollectionFolderModal.vue?vue&type=script&lang=js&"
export * from "./NewCollectionFolderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports